export const reducerName = 'SELECTED_LEAGUES_FOR_CLONING'

const ActionTypes = {
  SET_SELECTED_LEAGUES_FOR_CLONING: 'SET_SELECTED_LEAGUES_FOR_CLONING',
}

const initialState = {
  data: [],
}

const SelectedLeaguesForCloningReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_SELECTED_LEAGUES_FOR_CLONING:
      return {
        ...state,
        data: action.data,
      }

    default:
      return { ...state }
  }
}

export const setSelectedLeaguesForCloningAction = (leagues) => ({
  type: ActionTypes.SET_SELECTED_LEAGUES_FOR_CLONING,
  data: leagues,
})

export const setSelectedLeaguesForCloning = (leagues) => (dispatch) => {
  dispatch(setSelectedLeaguesForCloningAction(leagues))
}


export const selectSelectedLeaguesForCloning = state => state?.[reducerName]?.data
export const namedReducer = {[reducerName]: SelectedLeaguesForCloningReducer}

export const getInitialState = (cloneLeaguesSession) => {
  const loadedLeaguesByID = cloneLeaguesSession?.data?.leagues || {}
  const loadedLeaguesList = Object.entries(loadedLeaguesByID).map(([ leagueID, leagueConfig ]) => ({
    id: leagueID,
    name: leagueConfig.name,
    product: leagueConfig.product,
  }))

  return { data: loadedLeaguesList }
}

export default SelectedLeaguesForCloningReducer
